import React from "react";
import { Link } from "react-router-dom";
import "./Breadcrumbs.css"; // optional CSS for styling

const Breadcrumbs: React.FC = () => {

  return (
    <nav className="breadcrumb-nav">
      <ul className="breadcrumb-list">
        <li>
          <Link to="/">🏠 Home</Link>
        </li>
       
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
